// CheckboxCell — shared controlled boolean primitive for inline grid edits.
// Domain-neutral (Component_Contract Tier 1). Theme tokens only.
// Color-blind safe: the checkbox itself + a yes/no word carry the meaning (never color alone).
//
// Props:
//   value      — boolean-ish (true/false, 1/0, '1'/'0', 'true'/'false')
//   onChange   — (nextBool: boolean) => void
//   label?     — override the on/off words; default ['Yes','No']  → [onLabel, offLabel]
//   title?     — tooltip
//
// Stops click propagation so toggling never also toggles row-select / edit mode.

// Coerce assorted truthy encodings to a real boolean.
function toBool(v) {
  if (typeof v === 'boolean') return v;
  if (v == null) return false;
  const s = String(v).trim().toLowerCase();
  return s === '1' || s === 'true' || s === 'yes' || s === 'y';
}

export default function CheckboxCell({ value, onChange, label = ['Yes', 'No'], title }) {
  const checked = toBool(value);
  const [onWord, offWord] = label;
  return (
    <label
      title={title}
      onClick={e => e.stopPropagation()}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 5,
        // Inherits: in a grid cell DataGrid gives it the cell's edit font (cellFont),
        // so the Yes/No word reads like the cell's read text (Alex, 2026-10-15).
        fontSize: 'inherit', color: 'var(--th-text-body)', cursor: 'pointer',
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={e => onChange(e.target.checked)}
        onClick={e => e.stopPropagation()}
        style={{ cursor: 'pointer', margin: 0 }}
      />
      <span>{checked ? onWord : offWord}</span>
    </label>
  );
}
